import { render } from "./EditProfile.vue?vue&type=template&id=dedbd80e"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=dedbd80e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__